import React from 'react'
import { Col, Typography } from 'antd'

const RiepilogoCard = (props) => {
  return (
    <>
      <Typography.Title className='text-success'>
        {props.title}
      </Typography.Title>
      <Typography.Text className='text-semibold text-lg'>
        {props.subtitle}
      </Typography.Text>
      <Col xs={24} sm={24} md={24} lg={24}>
        {props.children}
      </Col>
    </>
  )
}

export default RiepilogoCard
